import { userState } from './reducers/userReducer';

export const initialState = {
  ...userState,
};
